import { inject, injectable } from 'tsyringe';
import { PersistentStorageService } from '../../persistent-storage-service/persistent-storage.service';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import {
  IUserActionService,
  IUserActionServiceDelegate,
  kNameOfUserActionService,
} from '../../../interfaces/user-action-service.interface';
import { LoggerService } from '../../logger.service';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.Global)
export class GlobalConditionGameExcluded
  implements ICondition, IUserActionServiceDelegate
{
  private readonly logger = LoggerService.getCategory(
    'GlobalConditionGameExcluded',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly storage: PersistentStorageService,
    @inject(kNameOfUserActionService)
    private readonly userActionService: IUserActionService,
  ) {
    this.userActionService.addListener(this);
  }

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const excludedGames = this.storage.getExcludedGames();
    if (!excludedGames) {
      return [true, null];
    }

    if (excludedGames.includes(context.game.id)) {
      return [false, NoRecommendationsReasons.GameExcludedByUser];
    }

    return [true, null];
  }

  // ---------------------------------------------------------------------------
  // IUserActionServiceDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  onGameExcluded(gameId: number) {
    this.storage.addGameToExcluded(gameId);
  }
}
